import { render } from "./PedidoFormView.vue?vue&type=template&id=62c45b3d&scoped=true"
import script from "./PedidoFormView.vue?vue&type=script&lang=js"
export * from "./PedidoFormView.vue?vue&type=script&lang=js"

import "./PedidoFormView.vue?vue&type=style&index=0&id=62c45b3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c45b3d"]])

export default __exports__